import { Component } from '@angular/core';
import { AuthService } from 'src/app/shared/auth/auth.service';
import { MdcService } from 'src/app/shared/mdc/mdc.service';

@Component({
  selector: 'app-step-end',
  templateUrl: './step-end.component.html',
})
export class StepEndComponent { 
  constructor(public mdcService: MdcService, public authService: AuthService) { }

  onImageError(event: Event): void {
    const target = event.target as HTMLImageElement;
    target.src = 'assets/images/falhou.png';
  }
}
